import { render } from "./ShopFollow.vue?vue&type=template&id=77532dfb&scoped=true"
import script from "./ShopFollow.vue?vue&type=script&lang=js"
export * from "./ShopFollow.vue?vue&type=script&lang=js"

import "./ShopFollow.vue?vue&type=style&index=0&id=77532dfb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77532dfb"]])

export default __exports__